"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var STATUS_OPTIONS = ['PENDING', 'APPROVED', 'REJECTED'];
var REJECTION_OPTIONS = ['INSUFFICIENT RESOURCES'];
var REJECTIONS_MAP = {
  'INSUFFICIENT RESOURCES': 'INSUFFICIENT_RESOURCES'
};

var Addon = /*#__PURE__*/function (_Component) {
  _inherits(Addon, _Component);

  var _super = _createSuper(Addon);

  function Addon() {
    var _this;

    _classCallCheck(this, Addon);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "handleChangeStatus", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var value, _this$props, addonValue, updateAddonStatus, addonType;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                value = _ref.value;
                _this$props = _this.props, addonValue = _this$props.addonValue, updateAddonStatus = _this$props.updateAddonStatus, addonType = _this$props.addonType;

                if (updateAddonStatus) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", void 0);

              case 4:
                if (!(value === 'REJECTED')) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", void _this.setState({
                  status: value
                }));

              case 6:
                _this.setState({
                  status: value,
                  rejectionReason: void 0
                });

                return _context.abrupt("return", void updateAddonStatus({
                  addonType: addonType,
                  status: value,
                  value: addonValue,
                  rejectionReason: void 0
                }));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleChangeRejection", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
        var value, _this$props2, updateAddonStatus, addonType, addonValue, status;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                value = _ref3.value;
                _this$props2 = _this.props, updateAddonStatus = _this$props2.updateAddonStatus, addonType = _this$props2.addonType, addonValue = _this$props2.addonValue;
                status = _this.state.status;

                if (!(!updateAddonStatus || !status)) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", void 0);

              case 5:
                _this.setState({
                  status: status,
                  rejectionReason: REJECTIONS_MAP[value]
                });

                return _context2.abrupt("return", void updateAddonStatus({
                  status: status,
                  addonType: addonType,
                  value: addonValue,
                  rejectionReason: REJECTIONS_MAP[value]
                }));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }());

    _this.state = {
      rejectionReason: void 0,
      status: void 0
    };
    return _this;
  }

  _createClass(Addon, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          icon = _this$props3.icon,
          label = _this$props3.label,
          submittedAt = _this$props3.submittedAt,
          statusProps = _this$props3.status,
          rejectionReasonProps = _this$props3.rejectionReason;
      var _this$state = this.state,
          statusState = _this$state.status,
          rejectionReasonState = _this$state.rejectionReason;
      var status = statusState || statusProps;
      var rejectionReason = rejectionReasonProps || rejectionReasonState;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "internal-mode-addons__list__addon"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "internal-mode-addons__list__addon__header"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
        size: 20,
        name: icon,
        color: "monkey"
      }), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        heading5: true
      }, label)), /*#__PURE__*/_react.default.createElement("div", {
        className: "internal-mode-addons__list__addon__info"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        heading5: true
      }, label), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        className: "internal-mode-addons__list__addon__info__submitted"
      }, "Submitted ".concat((0, _moment.default)(submittedAt, ['x', 'YYYY-MM-DDTHH:mm:ss.sssZ']).format('YYYY/MM/DD [at] H:mm a'))), /*#__PURE__*/_react.default.createElement(_uiKit.Dropdown, {
        options: STATUS_OPTIONS,
        defaultValue: status,
        label: "Status",
        onChange: this.handleChangeStatus,
        fontSize: 12,
        hideSeparators: true
      }), status === 'REJECTED' ? /*#__PURE__*/_react.default.createElement("div", {
        className: "internal-mode-addons__list__addon__info__rejection-reason"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Dropdown, {
        options: REJECTION_OPTIONS,
        defaultValue: Object.keys(REJECTIONS_MAP).find(function (key) {
          return REJECTIONS_MAP[key] === rejectionReason;
        }),
        label: "Reason for rejection*",
        onChange: this.handleChangeRejection,
        fontSize: 12,
        hideSeparators: true,
        color: "black"
      })) : null));
    }
  }]);

  return Addon;
}(_react.Component);

exports.default = Addon;